<template>
  <section id="experience">
    
    <Title
      class="title"
      :title="$t('experience.title')"
      :description="$t('experience.description')"
    />
	
		<div class="exp-container container-fluid" v-motion-slide-visible-bottom>
			<div class="row">
				<ExperienceColumn
					:posts="academicPosts"
          :title="$t('experience.education')"
					class="col-12 col-md left"
				/>
				<ExperienceColumn
					:posts="professionalPosts"
          :title="$t('experience.professional')"
					class="col-12 col-md right"
				/>
			</div>
		</div>
	
  </section>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import Title from "./Title.vue";
import ExperienceColumn from "./ExperienceColumn.vue";

export default {
  name: "Experience",
  setup() {
    const { t } = useI18n()
    // Dynamically build posts from translation keys
    const academicPosts = computed(() => [
      {
        year: t('experience.academic.0.year'),
        title: t('experience.academic.0.title'),
        content: t('experience.academic.0.content')
      },
      {
        year: t('experience.academic.1.year'),
        title: t('experience.academic.1.title'),
        content: t('experience.academic.1.content')
      }
    ])
    const professionalPosts = computed(() => [
      {
        year: t('experience.professional.0.year'),
        title: t('experience.professional.0.title'),
        content: t('experience.professional.0.content')
      },
      {
        year: t('experience.professional.1.year'),
        title: t('experience.professional.1.title'),
        content: t('experience.professional.1.content')
      },
      {
        year: t('experience.professional.2.year'),
        title: t('experience.professional.2.title'),
        content: t('experience.professional.2.content')
      }
    ])
    return {
      academicPosts,
      professionalPosts
    }
  },
  components: {
    Title,
    ExperienceColumn
  }
};
</script>

<style scoped lang="scss">
@import "@/styles/constants.scss";

$linear: map-get($colors, dark);

.exp-container {
  padding-left: 5%;
  padding-right: 5%;
}
#experience {
  background-color: lighten(map-get($colors, primary), 5%);
}

.title {
  color: map-get($colors, light);
}

.row {
  padding-top: 20px;
  text-align: center;
}


@media (min-width: #{map-get($breakpoints, small)}) {
  .left {
    text-align: right;
    border-right: 2px solid $linear;
  }
  .right {
    text-align: left;
  }
}

@media (max-width: #{map-get($breakpoints, small)}) {
  .right {
    margin-top: 20px;
  }
  .left:before {
    content : "";
    position: absolute;
    left    : 20%;
    bottom  : 0;
    height  : 2px;
    width   : 60%;  /* or 100px */
    border-bottom:2px solid $linear;
}
}

@media (max-width: 460px) {
  .exp-container {
  padding-left: 10%;
  padding-right: 10%;
}
}

/deep/ .text-wrapper {
  &:after {
    border-bottom: 1px solid map-get($colors, dark);
  }
}
</style>
